import axios from "axios";
import { API_URL } from "./conection";

export const requestToken = async (email) => {
  const res = await axios.post(`${API_URL}/auth/token`, { email });
  return res.data; // { token, expiresIn }
};
